<template>
  <div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search @search="search" />
      </div>
    </div>
    <div>
      <app-nav />
    </div>
    <div id="my-cart">
      <div id="header">
        <div class="cart-icon">
          <img src="../../../static/images/gouwuche_icon.png" alt="购物车小图标">
        </div>
        <div class="shop-process">
          <img src="../../../static/images/shop_process.png" alt="=购物流程图">
          <p>
            <span>我的购物车</span>
            <span>核对信息</span>
            <span>提交订单</span>
          </p>
        </div>
      </div>
      <div id="content">
        <div class="user-info">
          <h1>收货人信息</h1>
          <div class="user-details">
            <p class="shop-name">{{ userInfo.name }}</p>
            <p class="address">{{ userInfo.addr }}</p>
            <p class="phone">{{ userInfo.phone }}</p>
          </div>
        </div>
        <div class="pay-type">
          <h1>支付方式</h1>
          <div class="select-pay-type">
            <div v-for="(pay,index) in selectPayType" :key="index">
              <p :class="pay.obj" @click="checkPayType(pay.payType,index)">{{ pay.desc }}</p>
            </div>
          </div>
        </div>
        <div class="order-info">
          <h1>订单信息</h1>
          <div class="cart-head">
            <b-container class="bv-example-row">
              <b-row>
                <b-col>
                  <span class="select" :class="{'selected':checkAll}" @click="checkAllOrders" />全选
                </b-col>
                <b-col>通用名/商品名</b-col>
                <b-col>规格</b-col>
                <b-col>生产厂家</b-col>
                <b-col>批准文号</b-col>
                <b-col>大包装</b-col>
                <b-col>库存</b-col>
                <b-col>单位</b-col>
                <b-col>有效期至</b-col>
                <b-col>单价</b-col>
                <b-col>数量</b-col>
                <b-col>小计</b-col>
                <b-col>操作</b-col>
              </b-row>
            </b-container>
          </div>
          <div class="cart-body">
            <div v-for="(order,index) in orders" :key="index">
              <cart-order :order="order" @checkItems="select" @selectOrder="checkItemAll" @removeItem="remove" />
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div class="cart-count">
          <b-container class="bv-example-row">
            <b-row>
              <b-col class="operate">
                <span class="select" :class="{'selected':checkAll}" @click="checkAllOrders" />
                <span @click="checkAllOrders">全选</span>
                <span class="select-to-delete" @click="deleteMany">删除</span>
                <span class="delete-all" @click="clearCart">清空购物车</span>
              </b-col>
              <b-col class="submit">
                已选
                <em style="color:#f00;font-style:normal;">{{ countNum }}</em>
                件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商品总价：￥{{ countPrice }}
                <b-button variant="danger" size="lg" squared @click="submitOrders">提交</b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import { ItemService } from '../../service/ItemService'
import CartOrder from './CartOrder'
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'

export default {
  components: {
    'cart-order': CartOrder, 'app-nav': nav,
    search, topbar, 'app-footer': footer
  },
  data () {
    return {
      checked: 3,
      itemCart: this.$store.getters.itemCart,
      searchText: '',
      selectPayType: [
        { desc: '线下支付', payType: 3, obj: { 'pay-type-selected': true }},
        { desc: '银行支付', payType: 5, obj: '' },
        { desc: '微信支付', payType: 2, obj: '' },
        { desc: '支付宝支付', payType: 4, obj: '' }
      ],
      orders: [],
      userInfo: {},
      // 3-线下支付 2-微信支付 4-支付宝 5-银行 0-未选择支付方式 0 09900000
      payType: 3
    }
  },
  computed: {
    countNum: function () {
      let count = 0
      this.orders.forEach(order => {
        order.items.forEach(item => {
          if (item.checked) {
            count = count + item.num
          }
        })
        console.log(count, 'countNum')
      })
      return count
    },
    checkAll: function () {
      let checked = true
      if (this.orders.length === 0) {
        checked = false
      } else {
        this.orders.forEach(order => {
          order.items.forEach(item => {
            if (item.checked === false) {
              checked = false
            }
          })
        })
      }
      return checked
    },
    isCheckAll: function () {
      // 2-全选 0-一个都没有 1-选了商品
      let result = 1
      if (!this.checkAll) {
        const itemsChecked = []
        this.orders.forEach(order => {
          order.items.forEach(item => {
            if (item.checked) {
              itemsChecked.push(item)
            }
          })
        })
        if (itemsChecked.length === 0) {
          result = 0
        }
      } else {
        result = 2 // 全选
      }
      return result
    },
    countPrice: function () {
      let price = 0
      this.orders.forEach(order => {
        order.items.forEach(item => {
          if (item.checked) {
            price = price + item.num * item.showPrice
          }
        })
      })
      return price.toFixed(2)
    }
  },
  watch: {
    itemCart: {
      handler: function (val, oldVal) {
        this.dealItems(val)
      },
      immediate: true
    }
  },
  mounted () {
    this.loadUserInfo()
  },
  methods: {
    remove (itemId, orderId) {
      console.log(itemId, orderId)
      this.orders.forEach(order => {
        if (order.shopId === orderId) {
          order.items = order.items.filter(item => item.id !== itemId)
          this.selectOrder(orderId)
          if (order.items.length === 0) {
            this.orders = this.orders.filter(tmpOrder => tmpOrder.shopId !== orderId)
          }
        }
      })
    },
    search (str) {

    },
    deleteMany () {
      const itemIds = []
      this.orders.forEach(order => {
        const orderId = order.shopId
        order.items.forEach(item => {
          if (item.checked) {
            itemIds.push(item.id)
          }
        })
        order.items = order.items.filter(item => item.checked === false)
        if (order.items.length === 0) {
          this.orders = this.orders.filter(tmpOrder => tmpOrder.shopId !== orderId)
        }
      })
      if (itemIds.length === 0) {
        this.showToast('请选择需要删除的商品', '批量删除购物车')
        return
      }
      this.$store.commit('removeMany', itemIds)
    },
    clearCart () {
      if (this.orders.length === 0) {
        this.showToast('当前购物车无可删除的商品', '清空购物车')
        return
      }
      this.$store.commit('clearCart')
      this.orders = []
    },
    select (itemId, orderId) {
      console.log(this.orders, 'this.orders')
      console.log(itemId, orderId)
      this.orders.forEach(order => {
        if (order.shopId === orderId) {
          console.log(order.shopId)
          order.items.forEach(item => {
            if (item.id === itemId) {
              item.checked = !item.checked
              console.log(item.checked, 'item.checked')
            }
          })
        }
      })
      this.selectOrder(orderId)
    },
    checkItemAll (orderId) { // 是否选择该店铺
      this.orders.forEach(order => {
        if (order.shopId === orderId) {
          order.checked = !order.checked
          console.log(order.checked, 'order.checked')
          order.items.forEach(item => {
            this.$set(item, 'checked', order.checked)
            this.$forceUpdate()
            // item.checked = order.checked
            console.log(item.checked, 'item is checked')
          })
        }
      })
    },
    selectOrder (orderId) { // 该店铺商品是否被全部选中
      let allOrder = true
      this.orders.forEach(order => {
        if (order.shopId === orderId) {
          order.items.forEach(item => {
            if (!item.checked) {
              allOrder = false
            }
          })
          order.checked = allOrder
        }
      })
    },
    checkAllOrders () {
      const checkAll = this.checkAll
      this.orders.forEach(order => {
        order.checked = !checkAll
        order.items.forEach(item => {
          item.checked = !checkAll
          console.log(item.checked, 'item ======+==++++')
        })
      })
    },
    loadUserInfo () {
      const url = '/hy-sb-userinfo/addr/getaddrs'
      this.$axios.get(url).then((response) => {
        const { content = [] } = response
        this.dealUserInfo(content[0])
      })
    },
    dealUserInfo (userInfo) {
      var userinfo = {};
      ({ address: userinfo.addr, name: userinfo.name, phone: userinfo.phone } = userInfo)
      if (userinfo.phone === undefined || userinfo.phone === null || userinfo.phone === '') {
        userinfo.phone = this.$store.getters.userInfo.phone
      }
      this.userInfo = userinfo
      console.log(this.userInfo, 'userInfo')
    },
    dealItems (items) {
      console.log(items, 'itemcart')
      this.orders = []
      const itemMap = new Map()
      const orderMap = new Map()
      items.forEach((item) => {
        itemMap.set(item.id, item)
      })
      console.log(itemMap, 'itemsMap')
      const itemService = new ItemService(this.$axios)
      const itemId = items.map((item) => { return item.id })
      console.log(itemId, 'itemIds')
      itemService.loadFullInfo(itemId).then((itemsInfo) => {
        itemsInfo.forEach((item) => {
          const shopId = itemMap.get(item.id).shopId
          const orderItem = this.putItemsToOrder(item, itemMap)
          let order = orderMap.get(shopId)
          if (order === undefined) {
            order = []
          }
          order.push(orderItem.get(shopId))
          orderMap.set(shopId, order)
        })
        orderMap.forEach(order => {
          const orderInfo = {}
          orderInfo.shopName = order[0].shopName
          orderInfo.items = order
          orderInfo.checked = true
          orderInfo.remark = ''
          orderInfo.shopId = order[0].shopId
          this.orders.push(orderInfo)
        })
        console.log(this.orders, 'iteminfofull')
      })
    },
    putItemsToOrder (item, itemMap) {
      const tmpItem = {}
      const orderMap = new Map()
      const itemCart = itemMap.get(item.id);
      ({
        promotion: tmpItem.promotion, promotionType: tmpItem.promotionType,
        basicUnit: tmpItem.basicUnit, name: tmpItem.name, inventory: tmpItem.inventory, expiryTime: tmpItem.expiryTime,
        largeScale: tmpItem.largeScale, showPrice: tmpItem.showPrice, id: tmpItem.id, commonName: tmpItem.commonName,
        licenseNumber: tmpItem.licenseNumber, instructPrice: tmpItem.oldPrice, manufacturer: tmpItem.manufacturer, norm: tmpItem.norm } = item)

      tmpItem.num = itemCart.num
      if (!tmpItem.showPrice) { tmpItem.showPrice = tmpItem.oldPrice }
      if (tmpItem.promotionType !== -1) { tmpItem.showPrice = tmpItem.promotion.activePrice || tmpItem.showPrice }
      tmpItem.checked = true
      tmpItem.shopId = itemCart.shopId
      tmpItem.shopName = itemCart.shopName
      orderMap.set(itemCart.shopId, tmpItem)
      return orderMap
    },
    clearStyle () {
      this.selectPayType.forEach((payType) => {
        payType.obj = ''
      })
    },
    judegUserInfo () {
      const { addr, phone, name } = this.userInfo
      console.log(addr)
      if (phone && name) {
        return true
      } else {
        this.showToast('请检查您的地址是否完整', '提交订单')
      }
      return false
    },
    checkPayType (num, index) {
      this.clearStyle()
      if (this.payType === num) {
        this.payType = 0
        return
      }
      this.payType = num
      this.selectPayType[index].obj = { 'pay-type-selected': true }
      console.log(num, index, 'payType', this.payType)
    },
    dealSubmitOrders (isSubmit) {
      var url = '/hy-sb-order/purchaseOrder/add'
      const orders = []
      this.orders.forEach(order => {
        var items = []
        order.items.forEach(item => {
          if (item.checked) {
            const tmpItem = {
              itemId: item.id,
              quantity: item.num
            }
            items.push(tmpItem)
          }
        })
        if (items.length > 0) {
          const orderInfo = {
            receiverName: this.userInfo.name,
            phone: this.userInfo.phone,
            addr: this.userInfo.addr,
            payType: this.payType,
            orderItem: [],
            remark: ''
          }
          orderInfo.remark = order.remark
          orderInfo.logisShopId = order.shopId
          orderInfo.orderItem = items
          orders.push(orderInfo)
        }
      })
      console.log(orders, 'sumbit ordess')
      this.$axios({
        url: url,
        data: orders,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        method: 'post'
      }).then(response => {
        var { code, msg, content = [] } = response
        if (code === '1') {
          msg = msg.substring(3)
          console.log(msg, 'msg')
          this.$bvModal.msgBoxOk(msg)
        } else if (code === '0') {
          var orderIds = []
          content.forEach(order => {
            orderIds.push(order.id)
          })
          this.$router.push({ name: 'orderConfirm', params: { orderIds: orderIds }})
          console.log(orderIds, 'orderIds')
          this.clearSomeCart(isSubmit)
        }
      })
    },
    clearSomeCart (isSubmit) {
      console.log(isSubmit, 'isSumbit')
      if (isSubmit === 2) {
        this.clearCart()
      } else {
        this.deleteMany()
      }
    },
    showToast (tip, title) {
      this.$bvToast.toast(tip, {
        title: title,
        autoHideDelay: 2000
      })
    },
    submitOrders () {
      // 提交订单-模态框描述   信息-头部
      // this.$router.push({ name: 'orderConfirm', params: { orderIds: [2107462, 2107463] }})
      if (this.payType === 0) {
        this.showToast('请选择支付方式', '提交订单')
        return
      } else {
        const isSubmit = this.isCheckAll
        if (isSubmit === 0) {
          this.showToast('请选择商品', '提交订单')
          return
        } else {
          this.$bvModal.msgBoxConfirm('您确定要提交订单吗？', {
            title: '信息',
            centered: true,
            cancelTitle: '提交',
            okTitle: '取消',
            bodyClass: 'cart-body-modal',
            headerBorderVariant: 'light',
            footerBorderVariant: 'light',
            titleTag: 'span',
            okVariant: 'danger',
            buttonSize: 'lg'
          }).then(value => {
            if (!value) {
              this.dealSubmitOrders(isSubmit)
            } else {
              return
            }
          })
        }
      }
    }
  }
}
</script>
<style>
#my-cart {
  max-width: 1200px;
  text-align: center;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: #fff;
}
.modal-footer {
  justify-content:center;
  border-top: 0;
  padding: 2.5rem;
}
.modal-body {
  border: 0;
  justify-content: center;
}
.cart-body-modal {
  padding: 2.5rem  10rem 0;
}
.modal-footer .btn-danger {
  background-color: #e0e0e0;
  color: #000;
  height: auto;
  padding: 0.2rem 3.6rem;
}
.modal-footer .btn-secondary {
  background-color: #df3033;
  border-color:#ccc;
}
.modal-footer > :not(:first-child) {
  margin-left: 4.25rem;
}
.btn-lg  {
  padding: 0.2rem 3.6rem;
}
#my-cart #header {
  display: flex;
  height: 115px;
  line-height: 115px;
}
#header .cart-icon {
  flex: 275;
  text-align: center;
}
#header .shop-process {
  flex: 925;
  text-align: left;
  position: relative;
}
.shop-process p {
  position: absolute;
  height: 100%;
  width: 100%;
  line-height: 210px;
  top:0;
  padding-left: 50px;
  left: 0;
}
.shop-process p span {
  margin-right: 130px;
}
.modal-header {
  background-color: #e0e0e0;
  text-align: center;
  font-size: 0.875rem;
  padding: 0.8rem 14rem;
}
.order-info {
  padding-bottom: 224px;
}
span.select {
  display: inline-block;
  border: 1px solid #ccc;
  background-color: #fff;
  width: 16px;
  height: 16px;
  margin-right: 3px;
  cursor: pointer;
}
span.selected {
  background: url('../../../static/images/gou.png') no-repeat center;
}
.container {
  padding-right: 0;
  padding-left: 0;
}
.cart-head .col {
  padding-right: 0;
  padding-left: 0;
  flex-basis: auto;
  height: 36px;
  font-weight: normal;
  display: table-cell;
}
.cart-head .row {
  flex-wrap: nowrap;
  flex-direction: row;
  display: table;
}
.cart-head {
  border: 1px solid #ccc;
}
.cart-head .col:nth-of-type(1) {
  width: 88px;
  text-align: left;
  padding-left: 18px;
}
.cart-head .col:nth-of-type(2) {
  width: 132px;
}
.cart-head .col:nth-of-type(3) {
  width: 82px;
}
.cart-head .col:nth-of-type(4) {
  width: 112px;
}
.cart-head .col:nth-of-type(5) {
  width: 130px;
}
.cart-head .col:nth-of-type(6) {
  width: 56px;
}
.cart-head .col:nth-of-type(7) {
  width: 64px;
}
.cart-head .col:nth-of-type(8) {
  width: 40px;
}
.cart-head .col:nth-of-type(9) {
  width: 130px;
}
.cart-head .col:nth-of-type(10) {
  width: 44px;
}
.cart-head .col:nth-of-type(11) {
  width: 130px;
}
.cart-head .col:nth-of-type(12) {
  width: 106px;
}
.cart-head .col:nth-of-type(13) {
  width: 102px;
}
h1 {
  text-align: left;
  padding-left: 28px;
  font-size: 1.125rem;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 2.5rem;
}
.user-info h1 {
  line-height: 1.2;
  padding-bottom:10px;
}
#content .user-info {
  padding-bottom: 12px;
}
#content .user-details {
  background-color: #fff4e8;
  height: 30px;
  line-height: 30px;
  padding-left: 1.75rem;
  display: flex;
  position: relative;
}
.user-details p {
  padding-left: 1.5rem;
  padding-right: 5rem;
  margin: 0;
}
#content .pay-type {
  height: 95px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.pay-type .select-pay-type {
  display: flex;
}
.select-pay-type p {
  /* max-width: 164px; */
  box-sizing: border-box;
  height: 28px;
  flex: 15%;
  position: relative;
  line-height: 24px;
  font-size: 0.875em;
  padding: 0 45px;
  background-color: #fff;
  margin-right: 4rem;
  margin-bottom: 0;
  margin-left: 1.3rem;
  cursor: pointer;
  border: 2px solid #ccc;
}
.select-pay-type .pay-type-selected {
  border-color: #dd2727;
}
.select-pay-type .pay-type-selected::after {
  background-image: url('../../../static/images/pay_type_selected.png');
}
.select-pay-type p::after {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url('../../../static/images/pay_type.png') no-repeat center;
  content: '';
}
.order-head {
  background-color: #ccc;
}
.cart-head caption {
  font-weight: bold;
  font-size: 18px;
  color: #000;
}
.cart-head .table thead th {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
}
.order-header {
  background: #ccc;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.container {
  max-width: 100% !important;
}
.order-header .shop,
.order-header .remarks {
  text-align: left;
  line-height: 30px;
}
.order-header .form-control {
  width: 80%;
  height: 26px;
  box-shadow: 0px 0px 0px #000;
  margin-top: 2px;
}
#my-cart #footer {
  box-sizing: border-box;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 0 20px 0 3px;
}
#my-cart #footer .col {
  height: 60px;
  line-height: 60px;
  font-size: 0.875rem;
  font-weight: normal;
}
#my-cart #footer .operate span:not(.select) {
  margin: 0 15px;
  cursor: pointer;
}
.cart-count .operate {
  text-align: left;
}
.cart-count .submit {
  text-align: right;
}
.submit .btn {
  width: 120px;
  margin-left: 15px;
}
.btn-danger {
  margin: 0;
  padding: 0;
  height: 60px;
  border: 0;
  margin-top: -2px;
}
.btn-danger:focus {
  outline: 0;
  box-shadow: 0 0 0 0;
}
.col {
  text-align: center;
}
</style>
